import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from "react-intl";

import { withStyles } from "@material-ui/core/styles";
// import queryString from "query-string";
import qs from "qs";
import Spinner from "react-activity/lib/Spinner";
import withAuthorization from "../withAuthorization";
import { cloudFunctions } from "../../firebase";

import AppContainer from "../AppContainer";
import { Grid } from "../../../node_modules/@material-ui/core";

import "react-activity/lib/Spinner/Spinner.css";
import AppStoreLink from "../../components/AppStoreLink";
import ReturnLink from "../../components/ReturnLink";

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2
  },
  textField: {
    flex: 1,
    marginTop: theme.spacing.unit,
    marginBottom: 0
  },
  button: {
    marginTop: theme.spacing.unit * 2
  }
});

class StripeConnectOnboardFinishScreen extends Component {
  static propTypes = {
    authUser: PropTypes.shape({}),
    location: PropTypes.shape({}).isRequired,
    classes: PropTypes.shape({}).isRequired,
    intl: PropTypes.shape({}).isRequired
  };
  static defaultProps = {
    authUser: null
  };

  constructor(props) {
    super(props);

    this.state = {
      calledCloudFunction: false,
      updating: true,
      errorMessage: null
    };
  }

  componentDidMount() {
    // Don't call the Finish more than once
    const { calledCloudFunction } = this.state;
    if (calledCloudFunction) {
      return;
    }

    this.setState(
      {
        calledCloudFunction: true,
        updating: true
      },
      () => {
        const { location } = this.props;
        // const params = queryString.parse(location.search);
        // Get the location and remove the question mark
        const querystring = location.search.replace("?", "");
        const params = qs.parse(querystring);

        const { code, state } = params;

        cloudFunctions
          .stripeConnectFinishOnboard(code, state)
          .then(() => {
            //success => {
            this.setState({ updating: false });
          })
          .catch(errorMessage => {
            this.setState({ updating: false, errorMessage: errorMessage });
          });
      }
    );
  }

  translateMessage = messageID => {
    const { intl } = this.props;
    return intl.formatMessage({ id: messageID });
  };

  render() {
    const { updating, errorMessage } = this.state;
    const componentName = "StripeConnectOnboardFinishScreen";

    let title = this.translateMessage(`${componentName}.YoureGoodToGo`);
    if (updating) {
      title = this.translateMessage(`${componentName}.CompletingSetup`);
    }
    if (errorMessage) {
      title = this.translateMessage(`${componentName}.Error`);
    }

    return (
      <AppContainer>
        <h1>{title}</h1>
        <Grid container justify="center">
          <Grid style={{ maxWidth: 450, marginBottom: 100 }}>
            {updating ? (
              <div>
                <p style={{ marginBottom: 100 }}>
                  <FormattedMessage id={`${componentName}.PleaseStandBy`} />
                </p>
                <Spinner
                  size={40}
                  color="#aaaaaa"
                  style={{ margin: "0 auto" }}
                />
              </div>
            ) : errorMessage ? (
              <div>
                <p className="errorBox">{`${errorMessage}`}</p>
                <ReturnLink />
              </div>
            ) : (
              <div>
                <FormattedHTMLMessage id={`${componentName}.ThankYou`} />
                <AppStoreLink />
                <ReturnLink />
              </div>
            )}
          </Grid>
        </Grid>
      </AppContainer>
    );
  }
}

const mapStateToProps = state => ({
  authUser: state.sessionState.authUser
});

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(
  connect(mapStateToProps)(
    withStyles(styles)(withRouter(injectIntl(StripeConnectOnboardFinishScreen)))
  )
);



// WEBPACK FOOTER //
// ./src/screens/dashboard/StripeConnectOnboardFinishScreen.js